import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutReturnPage from "./pages/CheckoutReturnPage";
import CGVPage from "./pages/CGVPage";
import FAQPage from "./pages/FAQPage";
import ImplantationsPage from "./pages/ImplantationsPage";
import CheckInOutPage from "./pages/CheckInOutPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#F8FAFC]">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard/orders/:orderId" element={<OrderDetailPage />} />
                <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/return" element={<CheckoutReturnPage />} />
                <Route path="/cgv" element={<CGVPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/implantations" element={<ImplantationsPage />} />
                <Route path="/check-in-out" element={<CheckInOutPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <Toaster />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
